import { Component, OnInit } from '@angular/core';
import { LabelConstants } from '../../shared/constants/label-constants';
import { SkillService } from '../services/skill.service';
import { MessageService } from 'primeng/api';
import { SkillConstants } from '../constants/skill-constants';

@Component({
  selector: 'app-skill-library',
  templateUrl: './skill-library.component.html',
  styleUrls: ['./skill-library.component.scss']
})
export class SkillLibraryComponent implements OnInit{
  topBarTitle = 'Skill Search';
  isScreenAccessible = true;
  errorMessage = '';
  isSkillSliderOpen = false;
  isAuthorizationLoading = true;
  showAddSkillButton = false;

  constructor(private skillService: SkillService, private messageService: MessageService) {}

  ngOnInit(): void {
    this.errorMessage = '';
    this.checkSkillAuthorization();
  }

  checkSkillAuthorization() {
    this.isAuthorizationLoading = true;
    this.skillService.getSkillAuthorization().subscribe({
      next: (authorization) => {
        this.isScreenAccessible = true;
        this.showAddSkillButton = authorization.addSkillButton;
        this.isAuthorizationLoading = false;
      },
      error: (err) => {
        this.errorMessage = err.error;
        this.isScreenAccessible = false;
        this.showAddSkillButton = false;
        this.isAuthorizationLoading = false;
      }
    });
  }

  addSkill(){
    if (!this.showAddSkillButton) {
      return;
    }
    this.isSkillSliderOpen = true;
  }

  closeSkillSlider(isSliderActive: boolean) {
    this.isSkillSliderOpen = isSliderActive;
  }

}
